<template>
  <div class="l-row">
    <form-group :label="$t('category.label')">
      <multiselect
        v-model="newItem.from.category"
        :options="from.categories"
        selectLabel=""
        selectedLabel=""
        placeholder="Escolha"
      />
    </form-group>

    <div class="l-col-1@md vertical-center">
      <i class="i-arrow icon-arrow-right center"></i>
    </div>

    <form-group :label="$t('departments.label')" :columns="3">
      <multiselect
        v-model="departmentSelect"
        :options="to.departments"
        selectLabel=""
        selectedLabel=""
        placeholder="Escolha"
        group-label="channel"
        group-values="departments"
        track-by="value"
        label="label"
      />
    </form-group>

    <form-group :label="$t('productTypes.label')" :columns="3" v-if="newItem.to.department !== null && newItem.to.businessId !== null && showProductTypes">
      <multiselect
        v-model="newItem.to.productType"
        :options="to.productTypes"
        selectLabel=""
        selectedLabel=""
        placeholder="Escolha"
      />
    </form-group>

    <slot/>
  </div>
</template>

<script>
  import { cloneDeep } from 'lodash'
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import api from '@/api'
  import notifier from '@/notifier'
  import Multiselect from 'vue-multiselect'

  export default {
    data: () => ({
      from: {
        categories: []
      },
      to: {
        departments: [],
        productTypes: []
      },
      newItem: {
        from: {
          category: null
        },
        to: {
          department: null,
          businessId: null,
          productType: null
        }
      },
      items: [],
      departmentSelect: null,
      alreadyExists: false,
      showProductTypes: false,
      loaderCategories: true,
      cloneCategories: null,
      loaderDepartments: true
    }),
    props: {
      preset: {
        type: Object,
        required: true
      }
    },
    mounted () {
      this.$emit('loading', true)

      api.getCategories(this.preset.from.module.type, this.preset.from.module.identifier)
        .then(categories => {
          this.from.categories = categories
          this.loaderCategories = false
          this.hideItem()
          this.$emit('loading', this.loaderCategories || this.loaderDepartments)
        })
        .catch(() => notifier.error('Impossível carregar as categorias da Moovin.', 'Erro'))

      api.netshoes.getProductTemplateDepartments()
        .then(departments => {
          this.to.departments = departments
          this.loaderDepartments = false
          this.$emit('loading', this.loaderCategories || this.loaderDepartments)
        })
        .catch(() => notifier.error('Impossível carregar os departamentos da Netshoes.', 'Erro'))
    },
    methods: {
      hideItem () {
        if (!this.cloneCategories) {
          this.cloneCategories = cloneDeep(this.from.categories)
        }

        this.from.categories = cloneDeep(this.cloneCategories)

        for (let i in this.preset.items) {
          const item = this.preset.items[i]

          const index = this.from.categories.indexOf(item.from.category)
          if (index !== -1) {
            this.from.categories.splice(index, 1)
          }
        }
      },
      getProductTemplateProductTypes () {
        if (this.newItem.to.department === null || this.newItem.to.businessId === null) {
          return false
        }

        this.$emit('loading', true)

        this.newItem.to.productType = null

        api.netshoes.getProductTemplateProductTypes(this.newItem.to.businessId, this.newItem.to.department.replace(/ /g, '+'))
          .then(productType => {
            this.to.productTypes = productType
            this.$emit('loading', false)
          })
          .catch(() => notifier.error('Impossível carregar os tipos de produto da Netshoes.', 'Erro'))
      },
      addPresetItem () {
        this.$emit('loading', true)

        this.alreadyExists = false

        const item = {
          from: {
            category: this.newItem.from.category
          },
          to: {
            department: this.newItem.to.department,
            businessId: this.newItem.to.businessId,
            productType: this.newItem.to.productType
          }
        }

        const itemExist = this.preset.items.filter(
          itemPreset => (
            itemPreset.from.category === item.from.category &&
            itemPreset.to.department === item.to.department && item.to.businessId && itemPreset.to.productType === item.to.productType
          )
        )

        if (itemExist.length) {
          notifier.error('Esta predefinição já foi cadastrada.', 'Erro')
          this.alreadyExists = true
          this.$emit('loading', false)
          return false
        }

        this.preset.items.push(item)

        this.$emit('loading', false)
      },
      formatPreset () {
        return {
          'from': {
            'type': this.preset.from.type,
            'identifier': this.preset.from.identifier
          },
          'to': {
            'type': this.preset.to.type,
            'identifier': this.preset.to.identifier
          },
          'type': this.preset.type,
          'item': this.newItem
        }
      },
      emitEnabledAdd () {
        this.$emit('addItemEnable')
      }
    },
    watch: {
      'to.productTypes' (value) {
        this.showProductTypes = value.length > 0
      },
      'preset.items' (value) {
        this.items = value

        this.hideItem()
      },
      'newItem.from.category' () {
        this.emitEnabledAdd()
      },
      'departmentSelect' (value) {
        if (value === null) {
          return
        }

        this.newItem.to.department = this.departmentSelect.label
        this.newItem.to.businessId = this.departmentSelect.businessId

        this.getProductTemplateProductTypes()
        this.emitEnabledAdd()
      },
      'newItem.to.productType' () {
        this.emitEnabledAdd()
      },
      'newItem.to.department' (value) {
        if (value === null) {
          this.departmentSelect = null
        }
      }
    },
    components: {
      Panel,
      FormGroup,
      Multiselect
    }
  }
</script>

<style lang="sass" scoped>
  .center
    margin: 0 auto

  .vertical-center
    display: flex
    align-items: center
    min-height: 81px
</style>



// WEBPACK FOOTER //
// CategorizationAddItem.vue?06ba10fa